export default __webpack_public_path__ + "static/media/i22.66a864de.svg";